import { StaffDAppointmentIcon } from "../assets/svg";
import styles from "../index.module.scss";
import { Space, Tag } from "antd";
import profileImage from "../assets/images/profileImage.png";
// language data
export const languageData = {
  en: { value: "en", label: "ENG", dir: "ltr" },
  ar: { value: "ar", label: "عربي", dir: "rtl" },
};

export const weekDaysData = [
  { value: "Monday", label: "Monday" },
  { value: "Tuesday", label: "Tuesday" },
  { value: "Wednesday", label: "Wednesday" },
  { value: "Thursday", label: "Thursday" },
  { value: "Friday", label: "Friday" },
  { value: "Saturday", label: "Saturday" },
  { value: "Sunday", label: "Sunday" },
];

// dashboard-> appointment table column data
export const columns = [
  {
    title: <div style={{ paddingLeft: "20px" }}>Name</div>,
    dataIndex: "profilePricture",
    key: "profilePicture",
    render: (_, record) => (
      <Space size="small">
        <img
          src={record.profilePricture}
          alt="error"
          style={{ width: "39px", height: "39px", borderRadius: "39px" }}
        />
        {record.name}
      </Space>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>Gender</div>,
    dataIndex: "gender",
    key: "gender",
  },
  {
    title: <div style={{ textAlign: "center" }}>Time</div>,
    dataIndex: "time",
    key: "time",
  },
  {
    title: <div style={{ textAlign: "center" }}>Action</div>,
    dataIndex: "",
    key: "x",
    className: styles.actionContainer,
    render: () => <>...</>,
    align: "center",
  },
];
// dashboard-> appointment table row data
export const dataSource = [
  {
    key: "1",
    profilePricture: profileImage,
    name: "Ronald Richards",
    gender: <div style={{ textAlign: "center" }}>Male</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "2",
    profilePricture: profileImage,
    name: "Jane cooper",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "3",
    profilePricture: profileImage,
    name: "Leslie Alexander",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "4",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "5",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "6",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "7",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "8",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "9",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "10",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "11",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "12",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "13",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "14",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "15",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
  {
    key: "16",
    profilePricture: profileImage,
    name: "Jerome bell",
    gender: <div style={{ textAlign: "center" }}>Female</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
  },
];

// dashboard-> invoice table column data
export const invoiceColumnHeaderData = [
  {
    title: <div style={{ textAlign: "center" }}>Invoice No.</div>,
    dataIndex: "invoice_no",
    key: "invoice_no",
  },
  {
    title: <div style={{ textAlign: "center" }}>Date</div>,
    dataIndex: "date",
    key: "date",
  },
  {
    title: <div style={{ textAlign: "center" }}>Time</div>,
    dataIndex: "time",
    key: "time",
  },
  {
    title: <div style={{ textAlign: "center" }}>Amount</div>,
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    align: "center",
    render: (tags) => (
      <>
        {tags?.map((tag) => {
          let tagStyle = {};
          if (tag === "Paid") {
            tagStyle = {
              backgroundColor: "#E5FFE6",
              color: "green",
              padding: "5px",
              border: "none",
              width: "90px",
              borderRadius: "40px",
              textAlign: "center",
            };
          } else {
            tagStyle = {
              backgroundColor: "#FBE6E6",
              color: "#CB3A31",
              padding: "5px",
              border: "none",
              width: "90px",
              borderRadius: "40px",
              textAlign: "center",
            };
          }
          return (
            <Tag style={tagStyle} key={tag}>
              {tag}
            </Tag>
          );
        })}
      </>
    ),
  },
  {
    title: <div style={{ textAlign: "center" }}>Action</div>,
    dataIndex: "",
    key: "x",
    className: styles.actionContainer,
    render: () => <>...</>,
    align: "center",
  },
];
// dashboard-> invoice table row data
export const invoiceDataSource = [
  {
    key: "1",
    invoice_no: <div style={{ textAlign: "center" }}>#12364</div>,
    date: <div style={{ textAlign: "center" }}>19 Oct 2023</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
    amount: <div style={{ textAlign: "center" }}>$125</div>,
    tags: ["Paid"],
  },
  {
    key: "2",
    invoice_no: <div style={{ textAlign: "center" }}>#12364</div>,
    date: <div style={{ textAlign: "center" }}>19 Oct 2023</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
    amount: <div style={{ textAlign: "center" }}>$125</div>,
    tags: ["Due"],
  },
  {
    key: "3",
    invoice_no: <div style={{ textAlign: "center" }}>#12364</div>,
    date: <div style={{ textAlign: "center" }}>19 Oct 2023</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
    amount: <div style={{ textAlign: "center" }}>$125</div>,
    tags: ["Paid"],
  },
  {
    key: "4",
    invoice_no: <div style={{ textAlign: "center" }}>#12364</div>,
    date: <div style={{ textAlign: "center" }}>19 Oct 2023</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
    amount: <div style={{ textAlign: "center" }}>$125</div>,
    tags: ["Due"],
  },
  {
    key: "5",
    invoice_no: <div style={{ textAlign: "center" }}>#12364</div>,
    date: <div style={{ textAlign: "center" }}>19 Oct 2023</div>,
    time: <div style={{ textAlign: "center" }}>10:30 am</div>,
    amount: <div style={{ textAlign: "center" }}>$125</div>,
    tags: ["Paid"],
  },
];

// dashboard-> staff table column data
export const StaffColumnHeaderData = [
  {
    dataIndex: "profilePricture",
    key: "profilePicture",
    render: (_, record) => (
      <Space size="small">
        <img
          src={record.profilePricture}
          alt="error"
          style={{ width: "50px", height: "39px", borderRadius: "39px" }}
        />
        {record.name}
      </Space>
    ),
  },
  {
    key: "tags",
    dataIndex: "tags",
    render: (tags) => (
      <>
        {tags?.map((tag) => {
          let tagStyle = {};
          if (tag === "Active") {
            tagStyle = {
              backgroundColor: "#5AB849",
              color: "#ffffff",
              padding: "5px 40px",
              border: "none",
              borderRadius: "40px",
              textAlign: "center",
            };
          } else {
            tagStyle = {
              backgroundColor: "#CB3A31",
              color: "#ffffff",
              padding: "5px 35px",
              border: "none",
              borderRadius: "40px",
              textAlign: "center",
            };
          }
          return (
            <Tag style={tagStyle} key={tag}>
              {tag}
            </Tag>
          );
        })}
      </>
    ),
  },
];
// dashboard-> staff table row data
export const staffDataSource = [
  {
    key: "1",
    profilePricture: profileImage,
    name: "Ronald Richards",
    tags: ["Active"],
  },
  {
    key: "2",
    profilePricture: profileImage,
    name: "Jane cooper",
    tags: ["Inactive"],
  },
  {
    key: "3",
    profilePricture: profileImage,
    name: "Leslie Alexander",
    tags: ["Active"],
  },
  {
    key: "4",
    profilePricture: profileImage,
    name: "Jerome bell",
    tags: ["Active"],
  },
  {
    key: "5",
    profilePricture: profileImage,
    name: "Leslie Alexander",
    tags: ["Active"],
  },
  {
    key: "6",
    profilePricture: profileImage,
    name: "Ronald Richards",
    tags: ["Inactive"],
  },
  {
    key: "7",
    profilePricture: profileImage,
    name: "Jerome bell",
    tags: ["Active"],
  },
  {
    key: "8",
    profilePricture: profileImage,
    name: "Jane cooper",
    tags: ["Inactive"],
  },
];

// dashboard -> chart data

export const optionData = {
  colors: ["#5AB849", "#FE996C", "#1A64AF"],
  labels: ["Massage", "Household Cleanup", "Facial"],
  plotOptions: {
    pie: {
      donut: {
        labels: {
          show: true,
          total: {
            show: true,
            label: "Income ",
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: true,
    position: "bottom",
    horizontalAlign: "center",
    fontSize: "14px",
    markers: {
      width: 10,
      height: 10,
    },
  },
};

export const seriesData = [90, 70, 20];

// staff->table

// dashboard-> appointment table row data
export const staffTableRowData = [
  {
    key: "1",
    profilePricture: profileImage,
    time: <div style={{ textAlign: "center" }}>09:00 AM - 10:00 AM</div>,
    name: "Awwab Shu'aib",
  },
  {
    key: "2",
    profilePricture: profileImage,
    name: "Jane cooper",
    time: <div style={{ textAlign: "center" }}>09:00 AM - 10:00 AM</div>,
  },
  {
    key: "3",
    profilePricture: profileImage,
    name: "Leslie Alexander",
    time: <div style={{ textAlign: "center" }}>09:00 AM - 10:00 AM</div>,
  },
  {
    key: "4",
    profilePricture: profileImage,
    name: "Jerome bell",
    time: <div style={{ textAlign: "center" }}>09:00 AM - 10:00 AM</div>,
  },
];

// provider-dashbaord appointment data
export const appointmentData = [
  {
    appointment_date: "01/11/2023",
    appointment_type: "Video",
    time: "11:00am",
    customer_name: "Will Smith",
    staff_type: "Medical",
    staff_name: "Angie Will",
    charges: "100",
  },
  {
    appointment_date: "01/11/2023",
    appointment_type: "Video",
    time: "11:00am",
    customer_name: "Will Smith",
    staff_type: "Medical",
    staff_name: "Angie Will",
    charges: "100",
  },
  {
    appointment_date: "01/11/2023",
    appointment_type: "Video",
    time: "11:00am",
    customer_name: "Will Smith",
    staff_type: "Medical",
    staff_name: "Angie Will",
    charges: "100",
  },
  {
    appointment_date: "01/11/2023",
    appointment_type: "Video",
    time: "11:00am",
    customer_name: "Will Smith",
    staff_type: "Medical",
    staff_name: "Angie Will",
    charges: "100",
  },
];

// provider-dashbaord request data
export const requestData = [
  {
    request_date: "02/11/2023",
    appointment_date: "04/11/2023",
    appointment_type: "Chat",
    customer_name: "Chuck Norris",
    charges: "25",
  },
  {
    request_date: "02/11/2023",
    appointment_date: "04/11/2023",
    appointment_type: "Video",
    customer_name: "Chuck Norris",
    charges: "15",
  },
  {
    request_date: "02/11/2023",
    appointment_date: "04/11/2023",
    appointment_type: "Chat",
    customer_name: "Chuck Norris",
    charges: "55",
  },
  {
    request_date: "02/11/2023",
    appointment_date: "04/11/2023",
    appointment_type: "Video",
    customer_name: "Chuck Norris",
    charges: "85",
  },
];

export const termsConditionData = [
  {
    message: "Privacy Policy",
    description:
      "Your use of the website(s) on which these terms reside (including, without limitation, versions of such websites optimized for mobile)  and the content and services at this Site are subject to these Terms of Use (or “Terms”), which we may update from time to time",
  },
  {
    message: "Account Security",
    description:
      "You must create an account and provide certain information to access or use some of the services offered by dummyflights. If you choose not to create an account, you may access certain features as a visitor and are still subject to these terms.Your account is for your personal,non-commercial use only and you must provide complete and accurate information when creating an account with us. You are responsible for maintaining the confidentiality and security of your account information including any usernames or passwords, and are solely responsible for the activity that occurs on your account.",
  },
  {
    message: "Copyrights",
    description:
      "All contents and functionality on the Site, including text, graphics, logos, icons, and images and the selection arrangement thereof, is the exclusive property of dummyflights or its licensors, and is protected by U.S and international copyright laws. All rights not expressly granted are reserved.",
  },
];
